module.exports = __webpack_public_path__ + "img/twitter_colored.298b4967.svg";